export const STORE_ROLES_NAME = 'roles';

export const STATE_ALL_ROLES = 'allRoles';
export const STATE_USER_ROLE = 'userRole';

export const GETTER_ALL_ROLES = 'allRoles';
export const GETTER_USER_ROLE = 'userRole';

export const MUTATION_SET_ALL_ROLES = 'setAllRoles';
export const MUTATION_SET_USER_ROLE = 'setUserRole';

export const ACTION_GET_ALL_ROLES = 'getRoles';
export const ACTION_CREATE_ROLE = 'createRole';
export const ACTION_UPDATE_ROLE = 'updateRole';
export const ACTION_DELETE_ROLE = 'deleteRole';
